import React, { useEffect, useRef } from 'react';
import './ContextMenu.css';

const ContextMenu = ({ x, y, items, onClose }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };

        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);

    const adjustedX = Math.min(x, window.innerWidth - 250);
    const adjustedY = Math.min(y, window.innerHeight - 400);

    return (
        <div ref={menuRef} className="context-menu" style={{ top: adjustedY, left: adjustedX }}>
            {items.map((item, index) => (
                <React.Fragment key={index}>
                    {item.divider ? (
                        <div className="context-menu-divider" />
                    ) : (
                        <div
                            className={`context-menu-item ${item.disabled ? 'disabled' : ''} ${item.danger ? 'danger' : ''}`}
                            onClick={() => {
                                if (!item.disabled && item.onClick) {
                                    item.onClick();
                                    onClose();
                                }
                            }}
                        >
                            {item.icon && (
                                <div className="context-menu-icon">
                                    <i className={item.icon}></i>
                                </div>
                            )}
                            <span>{item.label}</span>
                            {item.shortcut && <span className="context-menu-shortcut">{item.shortcut}</span>}
                        </div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default ContextMenu;